'use strict';

(function () {
  var module = angular.module('client.services');

  module.service('CurriculumMode', ['$rootScope', '$q', '$location', '$log', '$routeParams', 'User',
    'curriculumReports', 'ReportNavigation',
    function ($rootScope, $q, $location, $log, $routeParams, User,
              curriculumReports, ReportNavigation) {

      // test to see if we are in district mode
      function isActiveMode() {
        return $location.path().indexOf('/experience') !== -1 && $location.path().indexOf('/experiences') === -1;
      }

      // Get the current report from the URL
      // named for brevity, in fact back-end returns report_key as report_id
      function currentReportKey() {
        return $routeParams.reportId;
      }

      // return the title when we are in curriculum mode
      function getTitle() {
        return $q.when("All Classes");
      }

      function navigateToExperiences() {
        $location.path('/experience');
      }

      function navigateToReports() {
        $location.path('/experience/reports');
      }

      function navigateToPack() {
        $location.path('/experience/class-pack');
      }

      function navigateToLicensePack() {
        $location.path('/experience/license-pack');
      }

      function navigateToLibrary() {
        $location.path('/experience/library');
      }

      function getReports() {
        return curriculumReports.getReports();
      }

      function getReportData(filter) {
        return curriculumReports.getReportData(currentReportKey(), filter);
      }

      function showReport(reportKey) {
        ReportNavigation.navigateToReport(reportKey, '/experience/report/' + reportKey,
          {}, $location.path());
      }

      return {
        isActiveMode: isActiveMode,
        getTitle: getTitle,
        navigateToExperiences: navigateToExperiences,
        navigateToReports: navigateToReports,
        navigateToPack: navigateToPack,
        navigateToLicensePack: navigateToLicensePack,
        navigateToLibrary: navigateToLibrary,
        getReports: getReports,
        getReportData: getReportData,
        showReport: showReport
      };
    }]);
})();
